const registerModal = (data) => { 
    if((data.variation === 'registerModal') || (data.variation === 'qrCodeModal')){
        const signupModalMain = document.getElementById("signupModalMain");
        const qrCodeModalMain = document.getElementById("qrCodeModalMain");
        const idleTime = (data.variation === 'registerModal') ? signupModalMain.getAttribute('data-idle-timeout') : qrCodeModalMain.getAttribute('data-idle-timeout');
        let count = 0;
        const isSignupOpened = CookieService.getCookie('signupOpened'); //Pop-up Opened
        function singupModule() {
            if(count === 0) {
                const signupLoadJsEvent = new CustomEvent('signupLoadJs');
                document.dispatchEvent(signupLoadJsEvent);
                CookieService.setCookie('signupOpened', true);
                count++;
            }
            const isLoggedIn = window.sessionStorage.getItem('AccountNumber')
            let userIdentity = CookieService.getCookie('userIdentity'); //registeredCustomer,existingCustomer, newCustomer 
            if(!userIdentity){
                CookieService.setCookie('userIdentity', 'newCustomer');
                userIdentity = CookieService.getCookie('userIdentity');
            }
            const isClosed = CookieService.getCookie('signupClosed');
            const isClosedQRCode = CookieService.getCookie('qrCodeClosed');           
            if((!isLoggedIn) && (userIdentity === 'newCustomer')){

                if((data.variation === 'registerModal') && (!isClosed) && (!isSignupOpened)) {
                    signupModalMain.classList.toggle("d-flex");

                } else if((data.variation === 'qrCodeModal') && (!isClosedQRCode)) {
                    qrCodeModalMain.classList.toggle("d-flex");
                }

                let currencyDropdownStatus = document.getElementById("currencydropdown"); // Hide drop-down
                if(currencyDropdownStatus && currencyDropdownStatus.style.display === 'block'){ 
                    currencyDropdownStatus.style.display = 'none'
                }

                if (typeof window.logPopUpEvent !== "undefined") {
                    window.logPopUpEvent();
                }
            }        
        };

        if(signupModalMain && idleTime > 0){
            inactivityTime(idleTime,singupModule);            
        }
    }    
}

(() => {    
    try {
        const signupModalMain = document.getElementById("signupModalMain");
        if (!signupModalMain) return;
        const disableEvergage = signupModalMain.getAttribute('data-disable-evergage');
        const isEvergageDisable = disableEvergage && (disableEvergage == 'Y') ? true : false;
        if(isEvergageDisable) {
            registerModal({variation: "registerModal"});     
        } else {
            registerModal({}); 
        }
    } catch(e) {
      // Error handled silently for security
    }    
})()